import axios from 'axios';
import API_ENDPOINTS from './api';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost/wedding/backend/api',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Redirect to login if unauthorized
      window.location.href = '/admin';
    }
    return Promise.reject(error);
  }
);

export default apiClient;